import React from 'react';
import logoImage from '../assets/images/logo.jpg';
import './Logo.css';

const Logo = () => {
  return (
    <img src={logoImage} alt="FM Ultratech Farms Logo" className="logo-img" />
  );
};

export default Logo;
